(() => {
  const sticky = document.querySelector(".sticky-atc");
  const stickyBtn = document.querySelector("[data-sticky-atc]");
  if (!sticky || !stickyBtn) return;

  const form =
    document.querySelector("form[action^='/cart/add']") ||
    document.querySelector("product-form form");

  if (!form) return;

  stickyBtn.addEventListener("click", () => {
    form.scrollIntoView({ behavior: "smooth", block: "center" });
    const realBtn = form.querySelector("button[type='submit'], [name='add']");
    if (realBtn) realBtn.focus({ preventScroll: true });
  });

  const obs = new IntersectionObserver(
    ([entry]) => {
      sticky.hidden = entry.isIntersecting;
    },
    { threshold: 0.15 }
  );

  obs.observe(form);
})();
